export default {
  defaultStyle: {
    height: "100%",
    // minHeight: "100vh"
  }
};
